import moment from 'moment-timezone';
import {
  CURRENCY_SETTINGS_REQUEST,
  CURRENCY_SETTINGS_FAILURE,
  CURRENCY_SETTINGS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function currencySettingsRequest() {
  return {
    type: CURRENCY_SETTINGS_REQUEST,
  };
}

function currencySettingsSuccess(data, token = null) {
  return {
    type: CURRENCY_SETTINGS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function currencySettingsError(message) {
  return {
    type: CURRENCY_SETTINGS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchCurrencySetting(fresh = true) {
  return (dispatch, getState) => {
    const { auth } = getState();
    let token = null;
    let reload = false;
    let companyID = '';
    if (auth && auth.company && auth.company.id) {
      companyID = auth.company.id;
    }
    dispatch(currencySettingsRequest());
    if (!fresh) {
      let currencySettingData = {};
      try {
        currencySettingData = JSON.parse(getItem(`${config.get('appName')}.currencySetting`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !currencySettingData.data ||
        config.get('version') !== currencySettingData.version ||
        moment().isAfter(moment(currencySettingData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(currencySettingsSuccess(currencySettingData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM(`/company/${companyID}/currency_setting/`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.currencySetting`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(currencySettingsSuccess(data, token));
      })
      .catch((err) => {
        dispatch(handleError(err, currencySettingsError));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/currencySetting.js